module.exports = __webpack_public_path__ + "img/2.555bff49.png";